import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { figmaColors } from '../../const/colors/figmaColors';
import { sizes } from '../../const/sizes';
const pulseAnimation = {
    '0%': { backgroundColor: figmaColors.grey1 },
    '50%': { backgroundColor: figmaColors.grey2 },
    '100%': { backgroundColor: figmaColors.grey1 },
};
const ANIMATION_DURATION = '1.6s';
const StyledSkeletonBlock = styled('div', (p) => ({
    width: p.$width ?? sizes.skeletonBlock.defaultWidth,
    height: p.$height ?? sizes.skeletonBlock.defaultHeight,
    borderRadius: p.$borderRadius ?? sizes.skeletonBlock.defaultBorderRadius,
    animationName: pulseAnimation,
    animationDuration: ANIMATION_DURATION,
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
}));
export const SkeletonBlock = ({ width, height, borderRadius, }) => {
    return (_jsx(StyledSkeletonBlock, { $width: width, $height: height, $borderRadius: borderRadius }));
};
